import React, { FC } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { Button } from '@whitesharx/starfall-frontend-ui-kit';
import { buttonStyles, contentStyles } from './styles.css';

const ContinueTool: FC<{ onContinue: () => void }> = ({ onContinue }) => {
  return (
    <Button color="secondary" fullWidth pulse className={buttonStyles} onClick={onContinue}>
      <p className={contentStyles}>{t('button.continue')}</p>
    </Button>
  );
};

export default ContinueTool;
